export const COLORS =Object.freeze({
    DEFAULT_RED:   Symbol("default-red"),
    LIGHT_PURPLE:  Symbol("light-purple"),
    DARK_PURPLE:  Symbol("dark-purple"),
    LIGHT_BLUE:  Symbol("light-blue"),
    DARK_BLUE:  Symbol("dark-blue"),
    LIGHT_AQUA:  Symbol("light-aqua"),
    DARK_AQUA:  Symbol("dark-aqua"),
    LIGHT_GREEN:  Symbol("light-green"),
    DARK_GREEN:  Symbol("dark-green"),
    LIGHT_YELLOW:  Symbol("light-yellow"),
    DARK_YELLOW:  Symbol("dark-yellow"),
    LIGHT_GREY:  Symbol("light-grey"),
    MEDIUM_GREY:  Symbol("medium-grey"),
    DARK_GREY:  Symbol("dark-grey"),
});

export const COLOR_VALUES = Object.values(COLORS).map(sym => sym.description);